
import SettingContext ,{iView,iAlert} from './setting-context'
import {useState,useEffect} from 'react'

const SettingProvider =(props:any)=>{
    const [openSidebar,setOpenSidebar]=useState(false)
    const [alert,setAlert]=useState<iAlert>({alertMessage:'',alertType:'error',openAlert:false,})
    const [view,setView]=useState({isTab:false,isMobile:false,isPc:false})
    let cb=  () =>{
   
        if (window.innerWidth > 567 && window.innerWidth <1024) {
          setView(pre=>({...pre,isTab:true,isMobile:false,isPc:false}))
        }
        if (window.innerWidth >1024) {
          setView(pre=>({...pre,isTab:false,isMobile:false,isPc:true}))
        }
        else {
          setView(pre=>({...pre,isTab:false,isMobile:true,isPc:false}))
        }
      }
      useEffect(() => {
        
        cb()
        window.addEventListener('resize',cb,false)
        return ()=>{
          window.removeEventListener('resize',cb)
        }
       
      }, []);
    return (
        <SettingContext.Provider
        value={
            {
               
           ...view,
               setView,
               alert,
               setAlert
        }
        }>
            {props.children}
        </SettingContext.Provider>
    )
}
export default SettingProvider;